import { call, put } from 'redux-saga/effects';
import bugsnagClient from '../../../../services/bugsnag/bugsnag';
import { fetchAnalyticTeamReportConfigAction } from '../fetchTeamReportConfig/action';
import { backendClient } from '../../../../services/api/backend-client';
import { showSnackbar } from '../../../../state/snackbar/snackbarSlice';

export function* createTeamReportConfigSaga(action) {
  try {
    const reportData = action.payload;
    const { teamId } = reportData;
    
    if (!teamId) {
      throw new Error('Team ID is required');
    }
    
    yield call([backendClient, backendClient.post], 'reports', reportData);

    yield put(fetchAnalyticTeamReportConfigAction({ teamId }));
    
    yield put(showSnackbar({
      message: 'Report scheduled successfully',
      severity: 'success',
    }));
  } catch (err) {
    bugsnagClient.notify(err);
    console.error('Failed to create analytic report configuration', err?.message);
    yield put(showSnackbar({
      message: 'Failed to schedule report',
      severity: 'error',
    }));
  }
}